import { render, staticRenderFns } from "./ProductOrderDetailsView.vue?vue&type=template&id=7af050aa&scoped=true&"
import script from "./ProductOrderDetailsView.vue?vue&type=script&lang=js&"
export * from "./ProductOrderDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderDetailsView.vue?vue&type=style&index=0&id=7af050aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af050aa",
  null
  
)

export default component.exports